import React from "react";
import { TempTestPage } from "../TempTestPage";

export default function TechStack() {
  var techonologiesName = [
    {
      Technology: "Frontend",
    },
    {
      Technology: "Backend",
    },
    {
      Technology: "Libraries",
    },
    {
      Technology: "Frameworks",
    },
    {
      Technology: "Modules",
    },
  ];
  var techonologiesContent = [
    {
      Frontend: [
        {
          Technology: "React.js",
          Img: "/images/Technology/frontendlogo1.png",
          alt: "React logo",
          title: "Frontend Technology React ",
        },
        {
          Technology: "Vue.js",
          Img: "/images/Technology/frontendlogo2.png",
          alt: "Vue.js logo",
          title: "Frontend Technology Vue.js",
        },
        {
          Technology: "D3.js",
          Img: "/images/Technology/D3js.svg",
          alt: "D3.js logo",
          title: "Frontend Technology D3.js",
        },
        {
          Technology: "TensorFlow",
          Img: "/images/Technology/TensorFlow.svg",
          alt: "TensorFlow logo",
          title: "Frontend Technology TensorFlow",
        },
      ],
      Backend: [
        {
          Technology: "Node.js",
          Img: "/images/Technology/backendlogo3.png",
          alt: "Node.js logo",
          title: "Backend Technology Node.js",
        },
        {
          Technology: "Python",
          Img: "/images/Technology/Python.png",
          alt: "Python logo",
          title: "Backend Technology Python",
        },
        {
          Technology: "Django",
          Img: "/images/Technology/Django.png",
          alt: "Django logo",
          title: "Backend Technology Django",
        },
        {
          Technology: "Ruby on Rails",
          Img: "/images/Technology/Ruby on Rails.png",
          alt: "Ruby on Rails logo",
          title: "Backend Technology Ruby on Rails",
        },
      ],
      CMS: [
        {
          Technology: "TensorFlow",
          Img: "/images/Technology/TensorFlow.svg",
          alt: "TensorFlow",
          title: "TensorFlow",
        },
        {
          Technology: "PyTorch",
          Img: "/images/Technology/PyTorch.png",
          alt: "PyTorch",
          title: "PyTorch",
        },
        {
          Technology: "NumPy",
          Img: "/images/Technology/NumPy.png",
          alt: "NumPy ",
          title: "NumPy ",
        },
        {
          Technology: "Pandas",
          Img: "/images/Technology/Pandas.png",
          alt: "Pandas",
          title: "Pandas",
        },
      ],
      DataBases: [
        {
          Technology: "FastAPI",
          Img: "/images/Technology/FastAPI.png",
          alt: "FastAPI",
          title: "Technology FastAPI",
        },
        {
          Technology: "Flask",
          Img: "/images/Technology/Flask.png",
          alt: "Flask",
          title: "Technology Flask",
        },
        {
          Technology: "PyTorch Lightning",
          Img: "/images/Technology/PyTorch Lightning.png",
          alt: "PyTorch Lightning",
          title: "Technology PyTorch Lightning",
        },
        {
          Technology: "Django Rest Framework",
          Img: "/images/Technology/Django Rest Framework.png",
          alt: "Django Rest Framework",
          title: "Technology Django Rest Framework",
        },
      ],
      CloudServices: [
        {
          Technology: "MLflow",
          Img: "/images/Technology/MLflow.png",
          alt: "MLflow",
          title: "MLflow",
        },
        {
          Technology: "Kubeflow",
          Img: "/images/Technology/Kubeflow.png",
          alt: "Kubeflow",
          title: "Kubeflow",
        },
        {
          Technology: "Apache Kafka",
          Img: "/images/Technology/Apache Kafka.png",
          alt: "Apache Kafka",
          title: "Apache Kafka",
        },
        {
          Technology: "Azure Machine Learning",
          Img: "/images/Technology/Azure Machine Learning.png",
          alt: "Azure Machine Learning",
          title: "Azure Machine Learning",
        },
      ],
    },
  ];
  return (
    <React.Fragment>
      <div className="row my-2 latestApiDevelopmentDiv ">
        <div className="col-12">
          <TempTestPage
            TechName={techonologiesName}
            TechContent={techonologiesContent}
            mainheader="Tech Stack"
            HeaderPadding="porttechHeading"
            SubHeaderCss="porttechSubHeading"
            flag={true}
            subHeader=""
          />
        </div>
      </div>
    </React.Fragment>
  );
}
